import 'core-js/stable';
import 'regenerator-runtime/runtime';
import mixpanel from 'mixpanel-browser';

import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
import { routerMiddleware } from 'react-router-redux';
import configureStore from './store/store';
import history from './history';
import { onLoad } from './onLoad';

import App from './App';

import * as serviceWorker from './serviceWorker';
import { configureWebsocketService } from './store/websocketService';
import { configureSessionService } from './store/sessionService';
import { isTestDevOrEnv } from './library/shared/environment';

// or with require() syntax:
// const mixpanel = require('mixpanel-browser');

// Enabling the debug mode flag is useful during implementation,
// but it's recommended you remove it for production
const productionHost = 'hitchpin.com';
const devToken = '71fe7274f6b7ad29519111696186184e';
const prodToken = '680304b41dc95b6b7e3bccec8de6e3f2';
const token =
  window.location.hostname.toLowerCase() === productionHost ||
  window.location.hostname.toLowerCase() === 'www.hitchpin.com'
    ? prodToken
    : devToken;

mixpanel.init(token, {
  debug: process.env.NODE_ENV === 'development',
  api_host: `${process.env.REACT_APP_API_URL.slice(
    0,
    process.env.REACT_APP_API_URL.length - 1,
  )}/tracking`,
});

mixpanel.register({ 'User Agent': navigator.userAgent });
if (/Prerender/i.test(navigator.userAgent)) {
  mixpanel.register({ $ignore: true });
}

// mixpanel.track('Sign Up', {
//   source: "Pat's affiliate site, john was here",
//   'Opted out of email': true,
// });

// ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);

const loadStripeScript = () => {
  const stripeScript = document.createElement('script');
  stripeScript.defer = true;
  stripeScript.src = isTestDevOrEnv
    ? 'https://js.stripe.com/v3/?advancedFraudSignals=false'
    : 'https://js.stripe.com/v3/';
  document.head.appendChild(stripeScript);
};
loadStripeScript();

if (process.env.NODE_ENV === 'production') {
  // Per sentry's recommendations on github issues, ignoring the non error promise rejection below -lj
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    ...(process.env.REACT_APP_VERSION
      ? { release: `hitchpin-react-app@${process.env.REACT_APP_VERSION}` }
      : {}),
    ...(process.env.REACT_APP_SENTRY_ENVIRONMENT
      ? { environment: process.env.REACT_APP_SENTRY_ENVIRONMENT }
      : {}),
    ignoreErrors: [
      'Non-Error promise rejection captured with value: Object Not Found Matching Id:',
      'Non-Error promise rejection captured with keys: body, status, statusText',
    ],
  });
}

serviceWorker.unregister();

// Create the redux store
const initialState = {
  account: { authed: Boolean(localStorage.getItem('token')) },
};
const { store } = configureStore([routerMiddleware(history)], initialState);

// Start the history listener
// startListener(history, store);

// Start Websocket Service
configureWebsocketService(store);
configureSessionService(store);
// idempotentStartWebsocketService()

// Render the application
const rootElement = document.getElementById('hitchpin-root');

const render = Component => {
  ReactDOM.render(
    <Provider store={store}>
      <Component history={history} />
    </Provider>,
    rootElement,
  );
};

if (module.hot) {
  module.hot.accept('./App', () => {
    // eslint-disable-next-line
    const NextApp = require('./App').default;
    render(NextApp);
  });
}

render(App);

onLoad();
